import { safeMerge } from "@components-common/utils";
import { custom } from "./custom";
import { index } from "./d_index";
import { defaultScreen } from "./default-screen";

export  const screen_defaults = {
  index: safeMerge(defaultScreen,index),
  custom: safeMerge(defaultScreen,custom),
}

export * from './public'
